import { LeadDetailAnalytics } from '@app/data/analytics';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { analytics } from '@repo/utils';

export interface LeadDetailTabState {
  activeTab?: string;
  // If true, the data in current tab will be refreshed,
  // its the responsibility of the tab to mark this as false
  requireDataRefresh?: boolean;
}

const initialState: LeadDetailTabState = {};

export const leadDetailTabSlice = createSlice({
  name: 'leadDetailTab',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<{
      tab: string;
      clickSource?: string;
    }>) => {
      const { tab, clickSource } = action.payload;

      if (clickSource) {
        analytics.click({
          click_type: LeadDetailAnalytics.SWITCH_TAB,
          click_text: tab,
          click_source: clickSource,
          custom: {
            previous_tab: state.activeTab,
            new_tab: tab,
          },
        });
      }

      state.activeTab = tab;
    },
    setRequireDataRefresh: (state, action: PayloadAction<boolean>) => {
      state.requireDataRefresh = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setRequireDataRefresh,
} = leadDetailTabSlice.actions;

export default leadDetailTabSlice.reducer;
